import styled from "styled-components";

export const Container = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	background-color: rgb(255, 255, 255, 0.8);
	font-size: 14px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 16px;
	z-index: 1;
	border-top-right-radius: 24px;

	span {
		color: #333;
	}
`;
